import { render } from "./MediaChat.vue?vue&type=template&id=7eeea6b2"
import script from "./MediaChat.vue?vue&type=script&lang=js"
export * from "./MediaChat.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\application\\chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__